import FetchHelper from "./FetchHelper";

import AuthManager from "./AuthManager";

import moment from "moment";

export default class Backend {
  static addDriver(driver) {
    let data = { ...driver };

    return FetchHelper.post(`${window.Api.Drivers}`, {
      user: driver.user,
      ...data,
    });
  }

  static updateDriver(driver) {
    let data = { ...driver };

    return FetchHelper.patch(`${window.Api.Drivers}/${driver.user.id}`, data);
  }

  static updateDriverDetails(driver) {
    let data = { ...driver };

    return FetchHelper.patch(`${window.Api.Drivers}/${driver.user.id}`, {
      user: data.user,
    });
  }

  static getDriverDetails(driverId) {
    console.log("Backend getDriverDetails: ", driverId)
    return FetchHelper.get(`${window.Api.Drivers}${driverId}/`);
  }

  static getDrivers() {
    return FetchHelper.get(`${window.Api.Drivers}`);
  }

  static pauseDriver(driver) {
    return FetchHelper.delete(`${window.Api.Drivers}/${driver.id}`);
  }

  static addVenue(venue) {
    let data = { ...venue };
    return FetchHelper.post(`${window.Api.Venues}`, data);
  }

  static getVenue(venueId) {
    return FetchHelper.get(`${window.Api.Venues}/${venueId}`);
  }

  static getVenueDetails(venueId) {
    return FetchHelper.get(`${window.Api.Venues}/${venueId}`);
  }

  static editVenue(venue) {
    let data = { ...venue };

    return FetchHelper.patch(`${window.Api.Venues}/${venue.id}`, data);
  }

  static updateVenue(venue) {
    let data = { ...venue };

    return FetchHelper.patch(`${window.Api.Venues}/${venue.id}`, data);
  }

  static testOrder(venue) {
    // This mocks data, but it is actually overwritten on the server side anyway
    // Prepare the items array based on what is expected on the server
    const items = [
      {
          id: 1,
          menu_item_id: 1,
          quantity: 1,
          price: 1200
      },
      {
          id: 2,
          menu_item_id: 2,
          quantity: 1,
          price: 2000
      }
    ];

    const body = {
        venue: venue.id,
        menu: venue.id,
        payment: {
            card: "1", // Mock card ID, can be dynamic if needed
            expected_price: items.reduce((total, item) => total + item.price, 0),
            tip: 0  // Adjust if you need a different value for the tip
        },
        items: items,
        instructions: "Test order instructions",
        address: 3,  // Optional, replace if needed
        //customer: 7,  // set on backend
        payment_intent_id: "mock_stripe_charge_id" // This implies the second call after payment completed
    };

    return FetchHelper.post(`${window.Api.TestOrder}`, body);
}

  static pauseVenue(venue) {
    return FetchHelper.patch(`${window.Api.Venues}/${venue.id}`, {
      paused: true,
    });
  }

  static unpauseVenue(venue) {
    return FetchHelper.patch(`${window.Api.Venues}/${venue.id}`, {
      paused: false,
    });
  }

  static getVendorDetails(vendorId) {
    return FetchHelper.get(`${window.Api.Companies}/${vendorId}`);
  }

  static getPasscode(vendorId) {
    return FetchHelper.get(`${window.Api.Companies}/${vendorId}?passcode=true`);
  }

  static updateVendor(vendor) {
    let data = { ...vendor };

    return FetchHelper.patch(`${window.Api.Companies}/${vendor.id}`, data);
  }

  static pauseVendor(vendor) {
    return FetchHelper.patch(`${window.Api.Companies}/${vendor.id}`, {
      status: "paused",
    });
  }

  static unpauseVendor(vendor) {
    return FetchHelper.patch(`${window.Api.Companies}/${vendor.id}`, {
      status: "active",
    });
  }

  static addCompanyDetails(company) {
    let data = { ...company };

    return FetchHelper.post(`${window.Api.Companies}`, {
      logo: data.logo.id,
      featured_image: data.featured_image.id,
    });
  }

  static updateCompanyDetails(company) {
    let data = { ...company };

    return FetchHelper.patch(`${window.Api.Companies}/${company.id}`, {
      logo: data.logo.id,
      featured_image: data.featured_image.id,
    });
  }

  static addCompany(company) {
    let data = { ...company };

    return FetchHelper.post(`${window.Api.Companies}`, data);
  }

  static getCompanyMembers(companyId) {
    return FetchHelper.get(
      `${window.Api.CompanyMembers}?company_id=${companyId}&paginated=false`
    ).then((response) => response.results);
  }

  static getCompanyMember(companyMember) {
    return FetchHelper.get(
      `${window.Api.CompanyMembers}`,
      companyMember.user.id
    );
  }

  static addCompanyMember(company) {
    let data = { ...company };

    return FetchHelper.post(
      `${window.Api.CompanyMembers}?company_id=${data.company}`,
      data
    );
  }

  static updateCompanyMember(companyMemberId, data) {
    return FetchHelper.patch(
      `${window.Api.CompanyMembers}${companyMemberId}/`,
      data
    );
  }

  static editCompany(company) {
    let data = { ...company };

    return FetchHelper.patch(`${window.Api.Companies}/${company.id}`, data);
  }

  static deleteCompany(companyId) {
    return FetchHelper.delete(`${window.Api.Companies}/${companyId}`);
  }

  static getStaff(companyId, venueId) {
    return FetchHelper.get(
      `${window.Api.Staff}?company_id=${companyId}&venue_id=${venueId}`
    ).then((response) => response.results);
  }

  static addStaff(companyMemberId, venueId) {
    let data = { company_member: companyMemberId, venue: venueId };

    return FetchHelper.post(`${window.Api.Staff}`, data);
  }

  static removeStaff(companyMemberId, venueId) {
    let data = { company_member_id: companyMemberId, venue_id: venueId };

    return FetchHelper.delete(`${window.Api.Staff}`, data);
  }

  static getCategories() {
    return FetchHelper.get(`${window.Api.Categories}?has_parent=false`).then(
      (response) => response.results
    );
  }

  static getMenuCategories(menu) {
    return FetchHelper.get(`${window.Api.MenuCategories}/${menu}`).then(
      (response) => response.results
    );
  }

  static addProductCategory(category) {
    let data = { ...category };
    return FetchHelper.post(`${window.Api.Categories}`, data);
  }

  static deleteCategory(id) {
    return FetchHelper.delete(`${window.Api.Categories}/${id}`);
  }

  static editProductCategory(category) {
    let data = { ...category };
    return FetchHelper.patch(`${window.Api.Categories}/${category.id}`, data);
  }

  static deleteSubCategory(id) {
    return FetchHelper.delete(`${window.Api.Categories}/${id}`);
  }

  static addMenuCategory(category) {
    let data = { ...category };
    return FetchHelper.post(`${window.Api.MenuCategories}`, data);
  }

  static getMenu(menu) {
    return FetchHelper.get(`${window.Api.Menus}/${menu}`);
  }

  static addMenu(menu) {
    let data = { ...menu };
    return FetchHelper.post(`${window.Api.Menus}`, data);
  }

  static editMenu(menu) {
    let data = { menu };
    return FetchHelper.patch(`${window.Api.Menus}/${menu}`, data);
  }

  static addMenuItem(item) {
    let data = { ...item };

    return FetchHelper.post(`${window.Api.MenuItems}`, {
      item: data.item,
      menu: data.menu,
      ...data,
    });
  }

  static editMenuItem(menuItem) {
    let data = { ...menuItem };
    return FetchHelper.patch(`${window.Api.MenuItems}/${menuItem.id}`, data);
  }

  static removeMenuItem(menuItemId) {
    return FetchHelper.delete(`${window.Api.MenuItems}/${menuItemId}`);
  }

  static addItem(item) {
    let data = { ...item };

    return FetchHelper.post(`${window.Api.Items}`, data);
  }

  static getItem(id) {
    return FetchHelper.get(`${window.Api.Items}/${id}`);
  }

  static editItem(item) {
    let data = { ...item };
    return FetchHelper.patch(`${window.Api.Items}/${item.id}`, data);
  }

  static removeItem(itemId) {
    return FetchHelper.delete(`${window.Api.Items}/${itemId}`);
  }

  // NOTE (Product Library search fix):
  // Added explicit product helpers so ProductLibrary.js can fetch/search/update/delete items while keeping the legacy API intact.
  // Assumes the backend accepts `search_term` plus standard pagination/order params.
  static _buildProductQueryParams({
    page,
    limit,
    sortBy,
    sortDir,
    type,
    searchTerm,
  } = {}) {
    const params = [];

    const encode = encodeURIComponent;

    if (page) {
      params.push(`page=${encode(page)}`);
    }

    if (limit) {
      params.push(`page_size=${encode(limit)}`);
    }

    if (type) {
      params.push(`type=${encode(type)}`);
    }

    if (sortBy) {
      let order = sortBy;
      if (sortDir === "desc") {
        order = `-${order}`;
      }
      params.push(`order_by=${encode(order)}`);
    }

    if (searchTerm) {
      params.push(`search_term=${encode(searchTerm)}`);
    }

    if (params.length === 0) {
      return "";
    }

    return `?${params.join("&")}`;
  }

  static getProducts(page = 1, limit = 10, sortBy, sortDir, type) {
    const query = Backend._buildProductQueryParams({
      page,
      limit,
      sortBy,
      sortDir,
      type,
    });

    return FetchHelper.get(`${window.Api.Items}${query}`);
  }

  static getProductsSearch(
    searchTerm,
    page = 1,
    limit = 10,
    sortBy,
    sortDir,
    type
  ) {
    const query = Backend._buildProductQueryParams({
      page,
      limit,
      sortBy,
      sortDir,
      type,
      searchTerm,
    });

    return FetchHelper.get(`${window.Api.Items}${query}`);
  }

  static deleteProduct(productId) {
    if (!productId) {
      return Promise.reject(new Error("Product ID is required"));
    }

    return FetchHelper.delete(`${window.Api.Items}/${productId}`);
  }

  static updateProduct(productId, data) {
    if (!productId) {
      return Promise.reject(new Error("Product ID is required"));
    }

    return FetchHelper.patch(`${window.Api.Items}/${productId}`, data);
  }

  static getCustomerDetails(customerId) {
    return FetchHelper.get(`${window.Api.Customers}/${customerId}`);
  }

  static getOverviewStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=total_earnings,sales_count`
    );
  }

  static getTotalEarnings() {
    return FetchHelper.get(`${window.Api.AllTimeStats}?types=total_earnings`);
  }

  static getDailyStats() {
    let maxDate = moment().endOf("isoWeek").format("YYYY-MM-DD");
    let minDate = moment().startOf("isoWeek").format("YYYY-MM-DD");

    return FetchHelper.get(
      `${window.Api.DailyStats}?max_date=${maxDate}&min_date=${minDate}&total=true`
    );
  }

  static getMonthlyStats() {
    let maxDate = moment().endOf("month").format("YYYY-MM-DD");
    let minDate = moment().startOf("month").format("YYYY-MM-DD");

    return FetchHelper.get(
      `${window.Api.DailyStats}?max_date=${maxDate}&min_date=${minDate}&total=true`
    );
  }

  static getVendorsStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=company_count,venue_count`
    ); 
  }

  static getDriversStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=driver_count,delivered_order_count`
    );
  }

  static getCustomersStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=customer_count,total_earnings,sales_count`
    );
  }

  static getOrderHistoryStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=delivered_order_count,rejected_order_count,average_wait_time`
    );
  }

  static getCancelledOrdersStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=delivered_order_count,rejected_order_count,average_wait_time`
    );
  }

  static getPaymentsHistoryStats() {
    return FetchHelper.get(
      `${window.Api.AllTimeStats}?types=platform_earnings,total_earnings,sales_count`
    );
  }

  static getGraphStats() {
    return FetchHelper.get(
      `${
        window.Api.DailyStats
      }?types=total_earnings,sales_count&starts_at=${moment()
        .startOf("week")
        .toISOString()}&ends_at=${moment().endOf("week").toISOString()}`
    );
  }

  static getAdmins() {
    return FetchHelper.get(`${window.Api.Admins}`).then(
      (response) => response.results
    );
  }

  static addAdmin(admin) {
    let data = { ...admin };
    return FetchHelper.post(`${window.Api.Admins}`, data);
  }

  static updateAdmin(admin) {
    let data = { ...admin };
    return FetchHelper.patch(`${window.Api.Admins}/${admin.user.id}`, data);
  }

  static removeAdmin(adminId) {
    return FetchHelper.delete(`${window.Api.Admins}/${adminId}`);
  }

  static getAgeDetails() {
    return FetchHelper.get(`${window.Api.Settings}?key=age_limit`).then(
      (response) => response.results[1]
    );
  }

  static updateAge(age) {
    let data = { ...age };
    return FetchHelper.post(`${window.Api.Settings}`, data);
  }

  static getMinimumOrderDetails() {
    return FetchHelper.get(
      `${window.Api.Settings}?key=minimum_order_amount`
    ).then((response) => response.results[0]);
  }

  static updateMinimumOrder(minimumOrder) {
    let data = { ...minimumOrder };
    return FetchHelper.post(`${window.Api.Settings}`, data);
  }

  static updateAccount(admin) {
    let data = { ...admin };
    return FetchHelper.patch(`${window.Api.Admins}/${admin.user.id}`, data);
  }

  static updateOrderDriver(id) {
    return FetchHelper.patch(`${window.Api.Orders}/${id}`, {
      driver: id,
    });
  }

  // For driver accepting/rejecting delivery requests
  static updateDeliveryRequest(id, data) {
    return FetchHelper.patch(`${window.Api.Orders}/${id}`, data);
  }

  static cancelOrder(orderId) {
    return FetchHelper.patch(`${window.Api.Orders}/${orderId}`, {
      status: "rejected",
    });
  }

  static completeOrder(orderId) {
    return FetchHelper.patch(`${window.Api.Orders}/${orderId}`, {
      delivery_status: "delivered",
      identification_status: "provided",
      identification: "123456789",
    });
  }

  static getDeliveryDistances() {
    return FetchHelper.get(`${window.Api.DeliveryDistances}`).then(
      (response) => response.results
    );
  }

  static createDeliveryDistances(deliveryDistances) {
    return FetchHelper.post(`${window.Api.DeliveryDistances}`, {
      delivery_distances: [...deliveryDistances],
    });
  }

  static uploadImage(image, type = "favicon") {
    let data = new FormData();

    data.append("file", image, image.name);
    data.append("type", type);

    return FetchHelper.post(window.Api.Images, data, true);
  }

  static uploadFile(file, endpoint, params) {
    let data = new FormData();

    data.append("csv", file, file.name);
    for (var key in params) {
      data.append(key, params[key]);
    }
    return FetchHelper.post(endpoint, data, true);
  }



static updateAdminEmailNotification(userId, data) {
  console.log("updateAdminEmailNotification userId:", userId, "data:", data);

  return FetchHelper.patch(`${window.Api.User.Base}/${userId}/email-notification`, data);
}


  // -------------------- Discounts / Promo Codes --------------------
  static getDiscounts() {
    return FetchHelper.get(`${window.Api.Discounts}`);
  }

  static createDiscount(payload) {
    return FetchHelper.post(`${window.Api.Discounts}`, payload);
  }

  static updateDiscount(id, payload) {
    return FetchHelper.patch(`${window.Api.Discounts}${id}/`, payload);
  }

  static deleteDiscount(id) {
    return FetchHelper.delete(`${window.Api.Discounts}${id}/`);
  }

  // Optional: apply promo (mostly for checkout flow, but handy)
  static applyPromo(promo_code, cart_total) {
    return FetchHelper.post(`${window.Api.ApplyDiscount}`, { promo_code, cart_total });
  }








  // ==================== BASKETS / HAMPERS ====================

  static getBaskets(params = {}) {
    let queryString = new URLSearchParams(params).toString();
    let url = queryString 
      ? `${window.Api.Baskets}?${queryString}` 
      : window.Api.Baskets;
    return FetchHelper.get(url);
  }

  static getBasket(basketId) {
    return FetchHelper.get(`${window.Api.Baskets}/${basketId}`);
  }

  static getBasketsStats() {
    return FetchHelper.get(`${window.Api.Baskets}/stats`);
  }

  static createBasket(basketData) {
    return FetchHelper.post(window.Api.Baskets, basketData);
  }

  static updateBasket(basketId, basketData) {
    return FetchHelper.patch(`${window.Api.Baskets}/${basketId}`, basketData);
  }

  static deleteBasket(basketId) {
    return FetchHelper.delete(`${window.Api.Baskets}/${basketId}`);
  }

  static toggleBasketVisibility(basketId, isActive) {
    return FetchHelper.patch(`${window.Api.Baskets}/${basketId}`, {
      is_active: isActive,
    });
  }

  // Basket Items
  static addBasketItem(basketId, itemData) {
    return FetchHelper.post(`${window.Api.BasketItems}`, {
      basket: basketId,
      ...itemData,
    });
  }

  static updateBasketItem(basketItemId, itemData) {
    return FetchHelper.patch(`${window.Api.BasketItems}/${basketItemId}`, itemData);
  }

  static deleteBasketItem(basketItemId) {
    return FetchHelper.delete(`${window.Api.BasketItems}/${basketItemId}`);
  }





  static getSalesOrders(params = {}) {
    const qs = new URLSearchParams(params).toString();

    // Prefer dedicated sales endpoint if available.
    if (window?.Api?.OrderSales) {
      return FetchHelper.get(qs ? `${window.Api.OrderSales}?${qs}` : window.Api.OrderSales);
    }

    // Fallback to the orders listing endpoint, which is widely available.
    if (window?.Api?.Orders) {
      return FetchHelper.get(qs ? `${window.Api.Orders}?${qs}` : window.Api.Orders);
    }

    // Last resort fallback when Api constants are unavailable.
    const url = qs ? `/orders/?${qs}` : `/orders/`;
    return FetchHelper.get(url);
  }






  // -------------------- Notifications --------------------
static previewNotificationAudience(payload) {
  // payload: { userType, filters }
  if (window?.Api?.NotificationPreview) {
    return FetchHelper.post(window.Api.NotificationPreview, payload);
  }
  // fallback if not present
  return FetchHelper.post("/notifications/preview/", payload);
}

static sendNotification(payload) {
  // payload: { title, message, userType, filters }
  if (window?.Api?.NotificationSend) {
    return FetchHelper.post(window.Api.NotificationSend, payload);
  }
  return FetchHelper.post("/notifications/send/", payload);
}

// -------------------- Notifications --------------------
// static getNotificationHistory(params = {}) {
//   const qs = new URLSearchParams(params).toString();

//   // ✅ best: configure window.Api.NotificationHistory
//   if (window?.Api?.NotificationHistory) {
//     return FetchHelper.get(qs ? `${window.Api.NotificationHistory}?${qs}` : window.Api.NotificationHistory);
//   }

//   // ✅ fallback: if your backend path is /notifications/history/
//   return FetchHelper.get(qs ? `/notifications/history/?${qs}` : `/notifications/history/`);
// }

static getNotificationHistory(params = {}) {
  const query = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null) {
      query.append(key, params[key]);
    }
  });

  if (window?.Api?.NotificationHistory) {
    return FetchHelper.get(`${window.Api.NotificationHistory}?${query.toString()}`);
  }

  return FetchHelper.get(`/notifications/history/?${query.toString()}`);
}

static previewNotificationAudience(payload) {
  if (window?.Api?.NotificationAudiencePreview) {
    return FetchHelper.post(window.Api.NotificationAudiencePreview, payload);
  }

  return FetchHelper.post("/notifications/preview/", payload);
}

static sendNotification(payload) {
  if (window?.Api?.NotificationSend) {
    return FetchHelper.post(window.Api.NotificationSend, payload);
  }

  return FetchHelper.post("/notifications/send/", payload);
}




static sendVerificationEmails(userIds) {
  return FetchHelper.post(
    `${window.Api.User.Base}/admin/send-verification-email`,
    {
      user_ids: userIds,
    }
  );
}






}





